<div class="container">
  <div class="logos">
    <img class="grt-logo" alt="GRTgaz Logo" src="/assets/logos/grt-gaz-logo.png">
    <div class="text">Powered by</div>
    <img class="noos-logo" alt="NooS Logo"  src="/assets/logos/noos-logo.png">
  </div>
  <div class="title">L’éthique en 3 clics</div>
  <div (click)="samlLogin()" class="button">Se connecter avec SSO</div>
</div>
